import { UpdateWPQDetail } from "../../../Services/wpq_details-service";
import { MessageTypes } from "../../utility/common/constants/CommonConstants";
import { checkProcessAdded as commonCheckProcessAdded, validateTestArray, checkDuplicateProcess as commonCheckDuplicateProcess, validateFirstPageFields } from "../../utility/common/TransactionComponents/TransactionValidationUtils";

export const checkProcessAdded = (detailObj) => {
  return commonCheckProcessAdded(detailObj, {
    processField: 'WPQ_Process',
    typeField: 'WPQ_Type',
    maxRows: 2
  });
};



export const check_TestArray = (WPQTestArray, fields, numrows) => {
  return validateTestArray(WPQTestArray, fields, numrows);
};

export const check_MacroMicroTest = (WPQTestArray, fields, numrows) => {
  return validateTestArray(WPQTestArray, fields, numrows);
};

  


export const check_MinimumLeakPath = (WPQTestArray, fields, numrows) => {
  return validateTestArray(WPQTestArray, fields, numrows);
};


 



export const page1characters = (error) => {
  let data = true;
  if (
    error.WPQ_WelderId.status === true ||
    error.WPQ_WelderName.status === true ||
    error.WPQ_Date.status === true ||
    error.WPQ_RecordNo.status === true ||
    error.WPQ_Wps_RecordNo.status === true ||
    error.WPQ_ReviNo.status === true ||
    error.WPQ_Inspection.status === true ||
    error.WPQ_Qualificationcode.status === true ||
    error.WPQ_BM_BM_ProductForm === true
  )
    return data;
};

export const checkduplicateProcess = (detailObj) => {
  return commonCheckDuplicateProcess(detailObj, {
    processField: 'WPQ_Process',
    typeField: 'WPQ_Type'
  });
};

export const checkFirstPageValidation = (radio, ANo, ChemicalAnalysis_TradeName, Classification, FNo, SFA, seterrobj) => {
  return validateFirstPageFields(radio, { ANo, ChemicalAnalysis_TradeName, Classification, FNo, SFA }, seterrobj);
};

//Tubesheet validation Started

export const checkTubeProcessAdded = (detailObj) => {
  return commonCheckProcessAdded(detailObj, {
    processField: 'WPSH_WPQ_Process',
    fNoField: 'WPSD_FM_FNo',
    SFAfield: 'WPSD_FM_SFA',
    maxRows: 1
  });
};

export const checkduplicateTubeProcess = (detailObj) => {
  return commonCheckDuplicateProcess(detailObj, {
    processField: 'WPSH_WPQ_Process',
    typeField: 'WPSD_FM_SFA'
  
  });
};


export const UpdateWPQDetailComplete = async (postList) => {

  let results = [],
    checkarray = [], len = 0;
  for (const element of postList) {

    console.log("iteration", element)

    len = len + 1



    let result = UpdateWPQDetail(element).catch((error) => {
    });
    if (result !== undefined) { results.push(result); }
    else {
      return result
    }

  }
  for (let result of results) {
    let check = await Promise.resolve(result);
    checkarray = [...checkarray, check];
  }
  console.log("chhha", checkarray)
  
  if (checkarray.length === 0) {

    return false;
  }
  else if (checkarray.filter((i) => i.message == MessageTypes.SpecialCharacters).length > 0) {

    return MessageTypes.SpecialCharacters
  }
  else {
    return true;
  }
};